import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function templateAlertModalReducer(state = initialState.templateAlertModal, action) {
    switch (action.type) {
        case types.SHOW_TEMPLATE_MODAL:
            return {
                ...state,
                ...{show: action.show},
                ...{title: action.title},
                ...{text: action.text}
            };
        case types.HIDE_TEMPLATE_MODAL:
            return {
                ...state,
                ...{show: false},
                ...{title: ''},
            };
        case types.ENABLE_TEMPLATE_MODAL:
            return {
                ...state,
                ...{canShowModal: action.status}
            };
        case types.DISABLE_TEMPLATE_MODAL:
            return {
                ...state,
                ...{canShowModal: action.status}
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/templates/templateAlertReducers.js